import { render, staticRenderFns } from "./recurrentAvoidedCosts.vue?vue&type=template&id=9b149038&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./recurrentAvoidedCosts.vue?vue&type=style&index=0&id=9b149038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b149038",
  null
  
)

export default component.exports